<template>
  <div>
    <button
      class="btn btn-primary mtwCta"
      aria-label="Move items to wishlist"
      :disabled="isTransferDisabled"
      @click="toggleWishlistModalHandler()">
      <slot>Move to wish list</slot>
    </button>

    <WishlistModal
      :show="showWishlistModal"
      :show-login-prompt="!internalLoggedIn"
      :product-id="productId"
      :transfer-order-line="transferOrderLine"
      @failed-transfers="
        val => {
          onFailedTransfers(val);
        }
      "
      @succussful-transfers="
        val => {
          onSuccessfulTransfers(val);
        }
      "
      @close="handleClose()"
      @login="internalLoggedIn = true">
      <template #login="slotProps">
        <slot name="login"
              v-bind="slotProps"></slot>
      </template>
    </WishlistModal>
    <ConfirmModal
      :show="showErrorDialogue"
      heading="Error transferring products"
      cancel-text="Okay"
      :show-confirm-button="false"
      @onClose="showErrorDialogue = false">
      <!-- failed to transfer -->
      <div v-if="failedProducts.length > 0">
        <p>
          The following products encountered an issue and could not be transferred
        </p>
        <ul>
          <li v-for="(item, index) in failedProducts"
              :key="index">
            {{ item.name }}
          </li>
        </ul>
      </div>
    </ConfirmModal>
  </div>
</template>

<script>
import WishlistModal from "~/Components/Wishlist/WishlistModal.vue";
import { getBasketId } from "~/Scripts/resources/basketStepResource";
import ConfirmModal from "~/Components/ConfirmModal.vue";

export default {
  name: "MoveOrderLineToWishList",
  components: {
    WishlistModal,
    ConfirmModal
  },
  props: {
    orderLine: {
      type: Object,
      default: () => {}
    },
    loggedIn: {
      type: Boolean,
      default: false
    }
  },
  data: () => ( {
    internalLoggedIn: false,
    showWishlistModal: false,
    transferOrderLine: null,
    failedProducts: [],
    showErrorDialogue: false
  } ),
  computed: {
    productId () {
      const { productId } = this.orderLine;
      return productId;
    },
    isTransferDisabled () {
      return this.transferOrderLine === null;
    }
  },
  watch: {
    loggedIn: {
      immediate: true,
      handler ( val ) {
        this.internalLoggedIn = val;
      }
    }
  },
  // eslint-disable-next-line
  created: function() {
    this.getBasketTransferObject().then( result => {
      this.transferOrderLine = result;
    } );
  },
  methods: {
    toggleWishlistModalHandler () {
      this.showWishlistModal = !this.showWishlistModal;
    },
    handleClose () {
      this.toggleWishlistModalHandler();
      this.$emit( "update" );
    },
    onFailedTransfers ( errors ) {
      this.failedProducts = Object.keys( errors.products ).reduce(
        // eslint-disable-next-line
        (prevKey, currKey) => ( errors.products[prevKey] || [] ).concat( errors.products[currKey] || [] ),
        []
      );

      this.showErrorDialogue = this.failedProducts.length > 0;
    },
    onSuccessfulTransfers ( transferResults ) {
      console.log( transferResults );
    },
    async getBasketTransferObject () {
      try {
        this.$emit( "loading", true );

        const { data: basketId } = ( await getBasketId() ) || {};
        const { id } = this.orderLine;

        return {
          orderHeaderId: basketId,
          orderLineId: id
        };
      } catch ( ex ) {
        console.error( ex );
      } finally {
        this.$emit( "loading", false );
      }

      return undefined;
    }
  }
};
</script>

<style lang="less" scoped>
.mtwCta {
  max-width: 200px;
  background-color: #007a7f;
  border: none;
  margin: 12px 0;

  &:hover {
    background-color: #00383a;
  }

  @media screen and (max-width: 768px) {
    font-size: 12px;
    padding: 3px 6px;
  }
}
</style>
